import { create } from 'zustand';
import { getCategoryTickets } from '../clients/ticket';
import { useCategoryStore } from './category';

export const useTicketStore = create((set) => ({
  tickets: [],
  totalTickets: 0,
  ticketLoading: false,
  ticketError: null,
  fetchTickets: async (accessToken, query) => {
    set({ ticketLoading: true, categoriesError: null });
    try {
      const { selectedChannels } = useCategoryStore.getState();
      
      let updatedQuery = query;
      if (selectedChannels?.length > 0) {
        selectedChannels.forEach((c) => (updatedQuery += `&channel=${c}`));
      }
      const response = await getCategoryTickets(accessToken, updatedQuery);
      set({
        tickets: response.tickets,
        totalTickets: response.total,
        ticketLoading: false,
      });
    } catch (error) {
      set({ ticketError: error.message, ticketLoading: false });
      console.log(error, '--error');
    }
  },
}));
